{% block sw_extension_card_base_activation_switch %}
<div class="sw-extension-card-base__info">
    <section>
        <span class="sw-extension-card-base__info-name">
            {{ extension.label }}
        </span>

        <span v-if="extension.inAppFeaturesAvailable" class="sw-extension-card-base__in-app-purchase__badge">
            {{ $t('sw-extension.in-app-purchase.badge-label') }}
        </span>
    </section>

    <button
        v-if="!isInstalled && isLegacyServicesExtension"
        class="sw-extension-card-base__open-services"
        type="button"
        @click="openLegacyServicesExtension"
        @keydown.enter="openLegacyServicesExtension"
    >
        {{ $t('sw-extension-store.legacyServices.openServices') }}
    </button>
</div>
{% endblock %}

{% block sw_extension_card_base_context_menu_actions_additional %}
    {% parent %}
    <sw-context-menu-item
        v-if="hasActiveInAppPurchases(extension.name)"
        class="sw-extension-card-base__in-app-purchase__store_link"
        @click="openAccountPage"
    >
        <sw-external-link>
            {{ $t('sw-extension.in-app-purchase.context-menu.account-link-label') }}
        </sw-external-link>
    </sw-context-menu-item>

    <sw-context-menu-item
        v-if="extension.inAppFeaturesAvailable"
        class="sw-extension-card-base__in-app-purchase__in-app-purchase-link"
        @click="openInAppPurchasesListingModal"
    >
        {{ $t('sw-extension.in-app-purchase.context-menu.in-app-purchases-label') }}
    </sw-context-menu-item>
{% endblock %}

{% block sw_extension_card_base_modals %}
    {% parent %}
    <sw-extension-store-in-app-purchases-listing-modal
        v-if="showInAppPurchasesListingModal"
        :extension="extension"
        :in-app-purchases="inAppPurchases"
        @modal-close="closeInAppPurchasesListingModal"
    />
{% endblock %}
